module.exports = __webpack_public_path__ + "images/decathlon797e0698642bcf88d9e0cfde9adf3d62.png";